export default __webpack_public_path__ + "static/media/werking-2.6a8125d1.JPG";